import TagManager from 'react-gtm-module';

export default function gtmPageView(location) {
  const path = location.pathname.startsWith('/white-tower')? location.pathname : '/white-tower' + location.pathname;

  TagManager.dataLayer({
    dataLayer: {
      event: 'pageview',
      page: path,
    },
  });
}